import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import GoogleLogin from 'react-google-login';
import FacebookProvider, {Login} from 'react-facebook';
import {Container} from 'flux/utils';

import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {List, ListItem} from 'material-ui/List';
import Snackbar from 'material-ui/Snackbar';
import LinearProgress from 'material-ui/LinearProgress';
import SvgIcon from 'material-ui/SvgIcon';

import AgrStore from './data/AgrStore';
import AgrActions from './data/AgrActions'

//import LanguageSelect from './LanguageSelect';

const FacebookIcon = <SvgIcon>
  <path
    fill="#000000"
    d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"/>
</SvgIcon>

const GoogleIcon = <SvgIcon>
  <path
    fill="#000000"
    d="M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z"/>
</SvgIcon>

class LoginDialog extends Component {

  static getStores() {
    return [AgrStore];
  }

  static calculateState() {
    var state = AgrStore.getState().toObject()

    var result = {
      loggedIn: state.loggedIn,
      loading: state.loginInProgress,
      snackMessage: state.snackMessage,
      snackMessageParams: state.snackMessageParams,
      onSnackAction: state.snackAction,
      snackAction: state.snackActionLabel
    }

    return result
  }

  handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleLogin()
    }
  }

  handleLogin = () => {
    this.refs.userName.setState({
      errorText: this.refs.userName.state.hasValue
        ? ""
        : this.formatMessage("app.login.error.enterUsername")
    })

    this.refs.password.setState({
      errorText: this.refs.password.state.hasValue
        ? ""
        : this.formatMessage("app.login.error.enterPassword")
    })

    if (!this.refs.userName.getValue() || !this.refs.password.getValue()) {
      return
    }

    AgrActions.login(
      {username: this.refs.userName.getValue(), password: this.refs.password.getValue()}
    )
  }

  getDialogActions = () => {
    if (this.state.loading) {
      return <LinearProgress mode="indeterminate"/>
    }

    var googleLogin = <GoogleLogin
      clientId="23311792537-qob1djv8p5ddc40hrobikbkkgp1mksgq.apps.googleusercontent.com"
      onSuccess={AgrActions.onGoogleLoginResponse}
      onFailure={AgrActions.onGoogleLoginFail}
      onRequest={AgrActions.loginStart}
      style={{
        border: 'none',
        padding: '0px',
        display: 'inline-block',
        marginRight: '10px'
      }}
      tag="div"
      prompt="select_account">
      <RaisedButton icon={GoogleIcon}/>
    </GoogleLogin>

    var facebookLogin = <FacebookProvider appId="348962841848059">
      <Login
        scope="email,public_profile"
        onResponse={AgrActions.onFacebookLoginResponse}
        onError={AgrActions.onFacebookLoginError}
        onWorking={AgrActions.loginStart}>
        <RaisedButton
          icon={FacebookIcon}
          style={{
            marginRight: '10px'
          }}/>
      </Login>
    </FacebookProvider>

    var defaultLogin = <RaisedButton
      tabIndex={3}
      label={this.formatMessage("app.login.signIn")}
      primary={true}
      onClick={this.handleLogin}/>

    return <div>
      {googleLogin}{facebookLogin}{defaultLogin}
    </div>
  }

  render() {
    var languageSelect = null
    //<LanguageSelect style={{float: 'right'}}/>

    var dialogTitle = <div>
      {this.formatMessage("app.login.signIn")}
      {languageSelect}
    </div>

    return <Dialog
      autoDetectWindowHeight={false}
      title={dialogTitle}
      modal={true}
      open={!this.state.loggedIn}
      actions={this.getDialogActions()}
      contentStyle={{
        overflow: 'hidden',
        minWidth: '360px'
      }}>
      <List>
        <ListItem disableKeyboardFocus={true}>
          <TextField
            autoFocus={true}
            hintText={this.formatMessage("app.login.hint.username")}
            fullWidth={true}
            tabIndex={1}
            ref='userName'
            onKeyPress={this.handleEnterKeyPress}/>
        </ListItem>
        <ListItem disableKeyboardFocus={true}>
          <TextField
            hintText={this.formatMessage("app.login.hint.password")}
            fullWidth={true}
            tabIndex={2}
            type='password'
            ref='password'
            onKeyPress={this.handleEnterKeyPress}/>
        </ListItem>

      </List>

      <Snackbar
        style={{
          textAlign: 'center',
          width: '100%'
        }}
        bodyStyle={{
          height: 'default',
          width: '100%',
          maxWidth: '100%'
        }}
        autoHideDuration={6000}
        open={this.state.snackMessage != null}
        message={this.state.snackMessage != null
          ? this.formatMessage(this.state.snackMessage)
          : ""}
        onActionClick={this.state.onSnackAction}
        action={this.formatMessage(this.state.snackAction)}
        onRequestClose={AgrActions.clearMessage}/>
    </Dialog>
  }

  formatMessage = (id, values) => {
    if (!id) {
      return ""
    }

    if (!values && this.state.snackMessageParams) {
      values = this.state.snackMessageParams.toObject()
    }

    return this.props.intl.formatMessage({
      id: id
    }, values)
  }
}

export default injectIntl(Container.create(LoginDialog))


// WEBPACK FOOTER //
// ./src/LoginDialog.js